// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Nszx8","modalButton":"modal_modalButton__rAxkw"};